import DashboardComponentWrapper from "../../components/dashboard/DashboardComponentWrapper"
import TabComponent from '../../components/ui/TabComponent'
import TableActionsComponent from "../../components/ui/Table/TableActionsComponent";
import PFAPFCDetailsList from "./PFAPFCDetails";

const header = [
    { field: 'pfc_name', headerName: 'PFC Name' },
    { field: 'contact_name', headerName: 'Contact Name' },
    { field: 'phone', headerName: 'Phone Number' },
    { field: 'email', headerName: 'Email' },
    {
        field: 'phone',
        headerName: 'Contact',
        lockPosition: 'left',
        pinned: "right",
        type: "actions",
        cellRenderer: ({ data }) => (
          <TableActionsComponent
            actions={[
              {
                component: data.phone ? (
                  <a href={`tel:${data.phone}`} className="w-full">
                    <button className='h-8 flex justify-center items-center !rounded-full bg-az-light-red text-az-teal !w-full px-4'>
                      <p className="w-fit text-left text-sm">Call Phone</p>
                    </button>
                  </a>
                ) : undefined,
              },
              {
                component: data.email ? (
                  <a href={`mailto:${data.email}`} className="w-full">
                    <button className='h-8 flex justify-center items-center !rounded-full bg-az-light-red text-az-teal !w-full px-4'>
                      <p className="w-fit text-left text-sm">Send Email</p>
                    </button>
                  </a>
                ) : undefined,
              },
            ]}
          />
        )
      }
];

const pfcDetails = [
    {
    "id":  1,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Olurotimi Oloyede",
    "email": "olurotimi.oloyede@ubagroup.com",
    "phone": "08060000624"
  },
  {
    "id":  2,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Blessing Onoja",
    "email": "blessing.onoja@ubagroup.com",
    "phone": "08094490294"
  },
  {
    "id":  3,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Yusuf Jeleel",
    "email": "yusuf.jeleel@ubagroup.com",
    "phone": "07064602363"
  },
  {
    "id":  4,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Onyeka Abanum",
    "email": "onyeka.abanum@ubagroup.com",
    "phone": "08032208805"
  },
  {
    "id":  5,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Christiana Nwosu",
    "email": "christiana.nwosu@ubagroup.com",
    "phone": "08023618859"
  },
  {
    "id":  6,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Morufat Sheriff",
    "email": "morufat.sheriff@ubagroup.com",
    "phone": "08054766473"
  },
  {
    "id":  7,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Mike Odion",
    "email": "mike.odion@ubagroup.com",
    "phone": "07045476381"
  },
  {
    "id":  8,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Atonye Ighoniseigha",
    "email": "atonye.igoniseigha@ubagroup.com",
    "phone": "08096753758"
  },
  {
    "id":  9,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Augustina  Alabintei",
    "email": "augustina.alabintei@ubagroup.com",
    "phone": "08039449293"
  },
  {
    "id":  10,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Omolabake Lawal",
    "email": "omolabake.lawal@ubagroup.com",
    "phone": "09024055875"
  },
  {
    "id":  11,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Emmanuel Nwachukwu",
    "email": "emmanuel.nwachukwu@ubagroup.com",
    "phone": "08060941138"
  },
  {
    "id":  12,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Oluchi Nwokobia",
    "email": "oluchi.nwaokobia@ubagroup.com",
    "phone": "07046421079"
  },
  {
    "id":  13,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Emmanuel Ataboh",
    "email": "emmanuel.ataboh@ubagroup.com",
    "phone": "09079885375"
  },
  {
    "id":  15,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "Olayinka Noiki",
    "email": "Olayinka.Noiki@ubagroup.com",
    "phone": "08038303985"
  },
  {
    "id":  16,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "ITSupport UBAPension",
    "email": "itsupportubapensions@ubagroup.com",
    "phone": "08032242002"
  },
  {
    "id":  17,
    "pfc_name": "UBA Pensions Custodian Limited",
    "contact_name": "David Ogunbode",
    "email": "david.ogunbode@ubagroup.com",
    "phone": "07061655916"
  },
  {
    "id":  18,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Edwin Osuya",
    "email": "Edwin.osuya@zenithcustodian.com",
    "phone": "08055619654"
  },
  {
    "id":  19,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "SAMUEL  ABU",
    "email": "Samuel.Chokos@zenithcustiodian.com",
    "phone": "08118699551"
  },
  {
    "id":  20,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "GLORIA  ODUMOSU",
    "email": "Gloria.Odumosu@zenithcustodian.com",
    "phone": "07031958963"
  },
  {
    "id":  21,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "KEHINDE  OLATIMEHIN",
    "email": "Kehinde.Olatimehin@zenithcustodian.com",
    "phone": "08165692347"
  },
  {
    "id":  22,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "BARAKAT  LAWAL",
    "email": "Barakat.Lawal@zenithcustodian.com",
    "phone": "08179036046"
  },
  {
    "id":  23,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "ATIOGBE  DAVID",
    "email": "David.Atiogbe@zenithcustodian.com",
    "phone": "08119603374"
  },
  {
    "id":  24,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "CHINONYE  NZETE",
    "email": "Chinonye.nzete@zenithcustodian.com",
    "phone": "08082285661"
  },
  {
    "id":  25,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "OBIAZI  PATRICK",
    "email": "Patrick.Obiazi@zenithcustodian.com",
    "phone": "08140028361"
  },
  {
    "id":  26,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "CHIZOBA  EZEALA",
    "email": "Chizoba.Ezeala@zenithcustodian.com",
    "phone": "08118022285"
  },
  {
    "id":  27,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "EWERE  ONYECHE",
    "email": "Ewere.Onyeche@zenithcustodian.com",
    "phone": "08137828164"
  },
  {
    "id":  28,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "MAXWELL  ODIGIRI",
    "email": "Maxwell.Odigiri@zenithcustodian.com",
    "phone": "08149573220"
  },
  {
    "id":  29,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "AJIBADE  BOLUWATIFE",
    "email": "Boluwatife.Ajibade@zenithcustodian.com",
    "phone": "08061748837"
  },
  {
    "id":  30,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "MARVELOUS  EBORKA",
    "email": "Marvellous.Eborka@zenithcustodian.com",
    "phone": "09064431113"
  },
  {
    "id":  31,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "IJEOMA  EMMANUEL",
    "email": "Ijeoma.Emmanuel@zenithcustodian.com",
    "phone": "08160280253"
  },
  {
    "id":  32,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "BENJAMIN  EJIDE",
    "email": "Benjamin.Ejide@zenithcustodian.com",
    "phone": "07061947130"
  },
  {
    "id":  33,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "JULIET  GOODEY",
    "email": "Juliet.Goddey@zenithcustodian.com",
    "phone": "08065031170"
  },
  {
    "id":  34,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "OLADAYO  DAWODU",
    "email": "Oladayo.Dawodu@zenithcustodian.com",
    "phone": "09033666447"
  },
  {
    "id":  35,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "SABO ISREAL",
    "email": "Israel.Sabo@zenithcustodian.com",
    "phone": "08135259938"
  },
  {
    "id":  36,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "EBENEZER  FAKAYODE",
    "email": "Ebenezer.Fakayode@zenithcustodian.com",
    "phone": "08139327451"
  },
  {
    "id":  37,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "FATIHU  YUSUF",
    "email": "Fatihu.Yusuf1@zenithcustodian.com",
    "phone": "09049699960"
  },
  {
    "id":  38,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Mary  Ogunsanya",
    "email": "Mary.Ogunsanya@zenithcustodian.com",
    "phone": "08022807032"
  },
  {
    "id":  39,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "JAMES  AJANI",
    "email": "james.ajani@zenithcustodian.com",
    "phone": "08178057143"
  },
  {
    "id":  40,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "FAITH  IGUODALA",
    "email": "Faith.Iguodala@zenithcustodian.com",
    "phone": "08151764495"
  },
  {
    "id":  43,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Abisola Faseeki",
    "email": "Abisola.Faseeki2@zenithcustodian.com",
    "phone": "08109329969"
  },
  {
    "id":  44,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Chidinma Okonkwo",
    "email": "Chidinma.Okonkwo3@zenithcustodian.com",
    "phone": "08058266136"
  },
  {
    "id":  45,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Miracle Eluromma",
    "email": "Miracle.Eluromma@zenithcustodian.com",
    "phone": "09055393214"
  },
  {
    "id":  46,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Nelly Ekeji",
    "email": "Nelly.Ekeji1@zenithcustodian.com",
    "phone": "08141622909"
  },
  {
    "id":  47,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Dorcas Ghomren",
    "email": "Dorcas.Ghomren@zenithcustodian.com",
    "phone": "09076442202"
  },
  {
    "id":  48,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Esther Anene",
    "email": "esther.anene@zenithcustodian.com",
    "phone": "07066392929"
  },
  {
    "id":  49,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Taiwo Olude",
    "email": "Taiwo.olude@zenithcustodian.com",
    "phone": "08145904051"
  },
  {
    "id":  50,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Miriam Ekeagba",
    "email": "Miriam.Ekeagba2@zenithcustodian.com",
    "phone": "08105757252"
  },
  {
    "id":  51,
    "pfc_name": "Zenith Pension Custodian Limited",
    "contact_name": "Andreas Ikwueme",
    "email": "Andreas.Ikwueme@zenithcustodian.com",
    "phone": "08149017591"
  },
  {
    "id":  52,
    "pfc_name": "First Pension Custodian Limited",
    "contact_name": "Muyiwa  Fagbenro",
    "email": "olumuyiwa.fagbenro@firstpensioncustodian.com",
    "phone": "08034050831"
  },
  {
    "id":  53,
    "pfc_name": "First Pension Custodian Limited",
    "contact_name": "NOIMOT  ABDULRASAQ-RUFAI",
    "email": "Noimot.A.AbdulRasaq-Rufai@firstpensioncustodian.com",
    "phone": "08033358933"
  },
  {
    "id":  54,
    "pfc_name": "First Pension Custodian Limited",
    "contact_name": "KEHINDE ALABI",
    "email": "Alabi.Kehinde@firstpensioncustodian.com",
    "phone": "08039193487"
  },
  {
    "id":  55,
    "pfc_name": "First Pension Custodian Limited",
    "contact_name": "ABIOLA DOHERTY",
    "email": "Doherty.M.ABIOLA@firstpensioncustodian.com",
    "phone": "08065182776"
  },
  {
    "id":  56,
    "pfc_name": "First Pension Custodian Limited",
    "contact_name": "ABIOLA OLAYIWOLA",
    "email": "Abiola.Olayiwola@firstpensioncustodian.com",
    "phone": "07068519313"
  },
  {
    "id":  57,
    "pfc_name": "First Pension Custodian Limited",
    "contact_name": "KELANI KABIRU",
    "email": "Kabiru.O.Kelani@firstpensioncustodian.com",
    "phone": "08055054460"
  },
  {
    "id":  58,
    "pfc_name": "First Pension Custodian Limited",
    "contact_name": "ABISOLA OWOLAB",
    "email": "Abisola.O.Owolabi@firstpensioncustodian.com",
    "phone": "07068519314"
  },
  {
    "id":  60,
    "pfc_name": "First Pension Custodian Limited",
    "contact_name": "Adesimiloluwa Olowolafe",
    "email": "Adesimiloluwa.o.olowolafe@firstpensioncustodian.com",
    "phone": "08087466974"
  }
]

const PFCDetails = () => {

    return (
        <div className="w-full h-full">
            <DashboardComponentWrapper
                title="PFCs"
                pageDetails="Get all your PFC Contacts."
            >
                <>
                    <TabComponent
                        components={{
                            'PFC Contacts': () => <PFAPFCDetailsList header={header} items={pfcDetails} />,
                        }}
                    />
                </>
            </DashboardComponentWrapper>
        </div>
    )
}

export default PFCDetails;
